"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinOurCelebration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="join-our-celebration" className="relative flex min-h-[70vh] items-center justify-center overflow-hidden py-32 md:py-48">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/floral_sunset_cta_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/floral_sunset_cta_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/floral_sunset_cta_bg.png-wvc-sizes" alt="Soft floral sunset arrangement" className="h-full w-full object-cover object-center" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-background/60 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto flex max-w-4xl flex-col items-center justify-center px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <h2 className="font-default text-foreground mb-8 text-5xl font-medium tracking-tight md:text-7xl lg:text-8xl">
          Will you join us?
        </h2>
        
        <p className="text-foreground/80 mb-12 max-w-2xl font-sans text-lg md:text-xl">
          We are thrilled to share this beautiful milestone with our closest friends and family. Please let us know if you will be able to celebrate with us.
        </p>

        {}
        <div className="group relative">
          {}
          <div className="absolute -inset-2 rounded-lg bg-primary/15 blur-lg transition-all duration-500 group-hover:bg-primary/25 group-hover:blur-xl"></div>
          
          <Button asChild size="lg" className="relative h-auto rounded-md px-12 py-5 text-lg shadow-xl transition-transform duration-300 hover:-translate-y-1">
            <Link to="/RSVPPage">
              RSVP Now
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}